<template>
  <div class="admin-area">
    <div class="text-center">
      <v-container>
        <v-row align-content="center" justify="center">
          <v-col xs="12" sm="12" md="12" lg="12" xl="12">
            <p class="text-h5">
              <span style="font-weight: bold"
                >Gérer dictionnaire de taxons</span
              >
            </p>
          </v-col>
        </v-row>
        <v-row align-content="center" justify="center">
          <v-col xs="12" sm="12" md="12" lg="12" xl="12">
            <v-expansion-panels multiple v-model="panel">
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">PH</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content
                      >Gérer Pollen Habit</v-list-item-content
                    >
                  </v-list-item></v-expansion-panel-header
                >
                <v-expansion-panel-content
                  ><CrudPollenHabit></CrudPollenHabit
                ></v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">F</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>Gérer Familles</v-list-item-content>
                  </v-list-item></v-expansion-panel-header
                >
                <v-expansion-panel-content
                  ><CrudTaxonFamilies></CrudTaxonFamilies
                ></v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">T</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content
                      >Gérer Taxonomies Revisées</v-list-item-content
                    >
                  </v-list-item></v-expansion-panel-header
                >
                <v-expansion-panel-content
                  ><CrudTaxons></CrudTaxons
                ></v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">TA</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content
                      >Gérer Taxonomies Auteur</v-list-item-content
                    >
                  </v-list-item></v-expansion-panel-header
                >
                <v-expansion-panel-content
                  ><CrudTaxonsAuteur></CrudTaxonsAuteur>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import CrudPollenHabit from "./CrudPollenHabit.vue";
import CrudTaxonFamilies from "./CrudTaxonFamilies.vue";
import CrudTaxons from "./CrudTaxons.vue";
import CrudTaxonsAuteur from "./CrudTaxonsAuteur.vue";
import { mapActions } from "vuex";
export default {
  components: {
    CrudPollenHabit,
    CrudTaxonFamilies,
    CrudTaxons,
    CrudTaxonsAuteur,
  },
  data() {
    return { panel: [3] };
  },
  methods: {
    ...mapActions([
      "fetchTaxons",
      "fetchAuthorTaxonsDeep",
      "fetchPollenHabits",
      "fetchHabitTypes",
      "fetchTaxonFamilies",
      "resetTaxonsFilters",
    ]),
    async loadData() {
      this.fetchHabitTypes();
      this.fetchPollenHabits();
      this.fetchTaxonFamilies();
      this.fetchTaxons();
      
    },
  },
  async created() {
    await this.loadData();
    this.fetchAuthorTaxonsDeep();
  },
};
</script>